import React, { useContext } from "react";
import { Configure, InstantSearch } from "react-instantsearch-dom";
import SearchAutocomplete from "app/pages/Faq/SearchAutocomplete/SearchAutocomplete";
import AppGlobalsContext from "app/AppGlobalsContext";
import "./FaqSearch.scss";
import {
	ALGOLIA_FAQ_INDEX_NAME,
	ALGOLIA_HITS_PER_PAGE,
	searchClient,
} from "app/utils/algolia/searchClient";

const FaqSearch = () => {
	const { brand, shop } = useContext(AppGlobalsContext);

	return (
		<div className="faq-search">
			<InstantSearch searchClient={searchClient} indexName={ALGOLIA_FAQ_INDEX_NAME}>
				<Configure
					filters={`brand:'${brand}' AND shop:'${shop}'`}
					hitsPerPage={ALGOLIA_HITS_PER_PAGE}
				/>
				<SearchAutocomplete />
			</InstantSearch>
		</div>
	);
};

export default React.memo(FaqSearch);
